import { Banner } from '@ths/ui';
import type { ReactNode } from 'react';

import { useTravelerSelfCheck } from '../hooks/useTravelerSelfCheck';

export default function TravelerSelfBookingGuard({
  children,
}: {
  children: ReactNode;
}) {
  const { canSelfBook, selfBookingEnabled } = useTravelerSelfCheck();
  if (canSelfBook) return <>{children}</>;

  return (
    <Banner status="info" className="mx-auto my-6 max-w-7xl">
      <p className="font-medium">
        {selfBookingEnabled ? 'Account not linked' : 'Self-booking unavailable'}
      </p>
      <p>
        {selfBookingEnabled
          ? 'Your account must be linked to a team member profile to book for yourself. Please contact your administrator.'
          : 'Traveler self-booking is not enabled for your client. Please contact your administrator for booking assistance.'}
      </p>
    </Banner>
  );
}
